import { DE } from '../locales/de.js';
import { EN } from '../locales/en.js';
import { ES } from '../locales/es.js';
import { FR } from '../locales/fr.js';
import { IT } from '../locales/it.js';
import { NL } from '../locales/nl.js';
import { PT } from '../locales/pt.js';
import { AppContext } from './app-context.js';
/**
 * Generic translator class for frontend modules.
 */
export class Translate {
    static { this.translations = {}; }
    static { this.defaulltTranslationsLoaded = false; }
    static { this._translations = new Map(); }
    static { this.getLanguage = () => {
        let lang = AppContext.getCurrentUser()?.lang ?? navigator.language;
        if (lang) {
            lang = lang.split('-')[0];
            if (lang === 'fr') {
                return lang;
            }
        }
        return lang;
    }; }
    static { this.loadDefaultTranslations = (lang) => {
        if (Translate.defaulltTranslationsLoaded) {
            return;
        }
        Translate.defaulltTranslationsLoaded = true;
        // Load the default components translations
        let defaultTranslations;
        switch (lang) {
            case 'en':
                defaultTranslations = new EN().getTranslations();
                break;
            case 'fr':
                defaultTranslations = new FR().getTranslations();
                break;
            case 'de':
                defaultTranslations = new DE().getTranslations();
                break;
            case 'it':
                defaultTranslations = new IT().getTranslations();
                break;
            case 'es':
                defaultTranslations = new ES().getTranslations();
                break;
            case 'pt':
                defaultTranslations = new PT().getTranslations();
                break;
            case 'nl':
                defaultTranslations = new NL().getTranslations();
                break;
            default:
                defaultTranslations = new EN().getTranslations();
        }
        let langBundle = Translate._translations.get(lang);
        if (!langBundle) {
            langBundle = new Map();
            Translate._translations.set(lang, langBundle);
        }
        for (const [key, value] of Object.entries(defaultTranslations)) {
            langBundle.set(key, String(value));
        }
    }; }
    static { this.load = (lang, json) => {
        this.clearCache();
        let langBundle = Translate._translations.get(lang);
        if (!langBundle) {
            langBundle = new Map();
            Translate._translations.set(lang, langBundle);
        }
        for (const key in json) {
            langBundle.set(key, json[key]);
        }
    }; }
    static { this.get = (key) => {
        const lang = Translate.getLanguage();
        this.loadDefaultTranslations(lang);
        return (Translate._translations.get(lang)?.get(key) ??
            Translate._translations.get('en')?.get(key) ??
            '[' + key + ']');
    }; }
    static { this.clearCache = () => {
        Translate._translations.clear();
        Translate.defaulltTranslationsLoaded = false;
    }; }
}
